import React, { memo, useEffect, useState } from "react";
import { observer } from "mobx-react";
import PopupForm from "app/common/Component/Popup/PopupForm";
import {
  Button,
  Grid,
  Popover,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useStylesExtraButton } from "app/common/Component/Table/TableComponent";
import { useTranslation } from "react-i18next";
import { SERVICE_REQUEST_STATUS } from "app/common/LocalConst";
import { getDateTime } from "app/common/LocalFunction";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import GlobitsPagination from "app/common/Component/Table/Pagination";

const columns = {
  stt: "STT",
  orderDate: "Ngày điều trị",
  service: "Dịch vụ",
  result: "Kết quả",
  department: "Cơ sở",
  room: "Phòng",
  assigner: "Người chỉ định",
  orderDateDetail: "Ngày chỉ định",
  performDate: "Thời gian thực hiện",
  performer: "Người thực hiện",
  hasImg: "Đã up ảnh",
  status: "Trạng thái",
  note: "Ghi chú",
  createdInfo: "Thông tin tạo / sửa",
  createDateInfo: "Ngày tạo HT / Thời gian nhập (theo HT)",
};

const dataInitColumn = {
  stt: true,
  orderDate: true,
  service: true,
  result: true,
  department: true,
  room: true,
  assigner: true,
  orderDateDetail: true,
  performDate: true,
  performer: true,
  hasImg: true,
  status: true,
  note: true,
  createdInfo: true,
  createDateInfo: true,
};
function HistoryTreatmentService({
  open,
  handleClose,
  searchData,
  pageDataHistory,
  handleChangeFormSearch,
}) {
  return (
    <PopupForm
      size="lg"
      title="Lịch sử điều trị"
      open={open}
      handleClose={handleClose}
      formik={{
        initialValues: searchData,
        enableReinitialize: true,
      }}
      hideSubmit
    >
      <Grid container spacing={1} className="w-100 m-0">
        <ValueForm
          handleChangeFormSearch={handleChangeFormSearch}
          pageDataHistory={pageDataHistory}
          searchData={searchData}
        />
      </Grid>
    </PopupForm>
  );
}

const ValueForm = observer(
  ({ pageDataHistory, searchData, handleChangeFormSearch }) => {
    const { t } = useTranslation();
    let dataShowTable =
      JSON.parse(localStorage.getItem("dataTableTreatmentServiceCustom")) || {};

    const totalItems = (pageDataHistory?.content || []).reduce(
      (acc, row) => acc + (row?.items?.length || 0),
      0
    );
    let stt = 0;

    const [visibleColumns, setVisibleColumns] = useState(dataInitColumn);

    useEffect(() => {
      if (Object.keys(dataShowTable).length > 0) {
        setVisibleColumns(dataShowTable);
      }
    }, []);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

    return (
      <Grid item xs={12}>
        {!isMobile && (
          <>
            <div className="flex justify-end">
              <ExtraButton
                setVisibleColumns={setVisibleColumns}
                visibleColumns={visibleColumns}
                columns={columns}
              />
            </div>
            <div className="table-scroll-wrapper">
              <table
                className="report-table-treatment"
                style={{ width: "100%", borderCollapse: "collapse" }}
              >
                <thead>
                  <tr style={{ background: "#f5f5f5" }}>
                    {visibleColumns["stt"] && <th>STT</th>}

                    {visibleColumns["orderDate"] && (
                      <th>
                        Ngày điều trị{" "}
                        <span style={{ color: "#bf3c3c", fontWeight: "bold" }}>
                          ({totalItems})
                        </span>
                      </th>
                    )}
                    {visibleColumns["service"] && <th>Dịch vụ</th>}
                    {visibleColumns["result"] && <th>Kết quả</th>}
                    {visibleColumns["department"] && <th>Cơ sở</th>}
                    {visibleColumns["room"] && <th>Phòng</th>}
                    {visibleColumns["assigner"] && <th>Người chỉ định</th>}
                    {visibleColumns["orderDateDetail"] && <th>Ngày chỉ định</th>}
                    {visibleColumns["performDate"] && (
                      <th>Thời gian thực hiện</th>
                    )}
                    {visibleColumns["performer"] && <th>Người thực hiện</th>}
                    {visibleColumns["hasImg"] && <th>Đã up ảnh</th>}
                    {visibleColumns["status"] && <th>Trạng thái</th>}
                    {visibleColumns["note"] && <th>Ghi chú</th>}
                    {visibleColumns["createdInfo"] && (
                      <th>Thông tin tạo / sửa</th>
                    )}
                    {visibleColumns["createDateInfo"] && (
                      <th>Ngày tạo HT / Thời gian nhập (theo HT)</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {(pageDataHistory?.content || []).map((row, index) =>
                    (row?.items || []).map((item, subIndex) => {
                      stt++;
                      return (
                        <tr key={`${index}-${subIndex}`}>
                          {visibleColumns["stt"] && <td>{stt}</td>}
                          {subIndex === 0 && visibleColumns["orderDate"] && (
                            <td rowSpan={row?.items?.length || 1}>
                              {getDateTime(row?.orderDate, "", "DD/MM/YYYY")}{" "}
                              <span style={{ color: "red" }}>
                                ({row?.items?.length})
                              </span>
                            </td>
                          )}
                          {visibleColumns["service"] && (
                            <td>
                              <div className="pl-1 pr-1">
                                <div>
                                  <span className="service-code">
                                    {item?.service?.code}
                                  </span>{" "}
                                  <span className="service-name">
                                    {item?.service?.tradeName ||
                                      item?.service?.name}
                                  </span>
                                  {item?.patientServiceRegisterCode && (
                                    <>
                                      {" - "}
                                      <span
                                        className="order-code"
                                        style={{
                                          color: "#888",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {item?.patientServiceRegisterCode}
                                      </span>
                                    </>
                                  )}
                                </div>

                                {item?.times && (
                                  <span className="font-size-12">
                                    {`Lần điều trị: ${item?.times || 0} ${item?.unLimited
                                        ? "♾️"
                                        : "| " + (item?.totalTreatmentTimes || 0)
                                      }`}
                                  </span>
                                )}
                                {/* <div className="flex mt-2">
                                      <div>
                                          Đã thu:{" "}
                                          <b style={{ color: "green" }}>
                                          {formatMoney(item?.psrTotalBillPatientPaid|| 0)}
                                          </b>
                                      </div>
                                      <span className="mx-2 text-gray-400">|</span>
                                      <div>
                                          Cần thu:{" "}
                                          <b style={{ color: "red" }}>
                                          {formatMoney(item?.psrAmountActuallyPaid)}
                                          </b>
                                      </div>
                                      </div> */}
                              </div>
                            </td>
                          )}
                          {visibleColumns["result"] && (
                            <td>
                              {item?.diagnosticReport ? (
                                <div>
                                  <div>
                                    <strong>Kết luận:</strong>{" "}
                                    {item?.diagnosticReport?.conclude ||
                                      "Không có"}
                                  </div>
                                  <div>
                                    <strong>Ghi chú:</strong>{" "}
                                    {item?.diagnosticReport?.note || "Không có"}
                                  </div>
                                </div>
                              ) : (
                                <i style={{ color: "#999" }}>Chưa có kết quả</i>
                              )}
                            </td>
                          )}
                          {visibleColumns["department"] && (
                            <td>{item?.department?.name || ""}</td>
                          )}
                          {visibleColumns["room"] && (
                            <td>{item?.room?.name || ""}</td>
                          )}
                          {visibleColumns["assigner"] && (
                            <td>{item?.assigner?.staffName || ""}</td>
                          )}
                          {visibleColumns["orderDateDetail"] && (
                            <td>{getDateTime(item?.orderDate)}</td>
                          )}
                          {visibleColumns["performDate"] && (
                            <td>{getDateTime(item?.performDate)}</td>
                          )}
                          {visibleColumns["performer"] && (
                            <td>
                              {item?.encounterParticipants?.map((el, ind) => (
                                <div>
                                  <span className="service-name">
                                    {el?.staff?.staffName}
                                    {": "}
                                  </span>
                                  <span
                                    className="service-code"
                                    style={{
                                      fontWeight: "400",
                                      fontSize: "12px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {el?.position?.name}{" "}
                                    {el?.isMain ? " - ⭐" : ""}
                                  </span>
                                </div>
                              ))}
                            </td>
                          )}
                          {visibleColumns["hasImg"] && (
                            <td>{item?.hasImg ? "✔️" : "❌"}</td>
                          )}
                          {visibleColumns["status"] && (
                            <td>
                              <span>
                                {SERVICE_REQUEST_STATUS?.find(
                                  (it) => it.value === item?.itemStatus
                                )?.name || t("Chưa xác định")}
                              </span>
                            </td>
                          )}
                          {visibleColumns["note"] && <td>{item?.note || ""}</td>}
                          {visibleColumns["createdInfo"] && (
                            <td>
                              <div>
                                <strong>Tạo:</strong> {item?.createdBy || ""}
                              </div>
                              <div>
                                <strong>Sửa:</strong> {item?.modifiedBy || ""}
                              </div>
                            </td>
                          )}
                          {visibleColumns["createDateInfo"] && (
                            <td>
                              <div>
                                <strong>Tạo HT:</strong>{" "}
                                {getDateTime(item?.createDate)}
                              </div>
                              <div>
                                <strong>Nhập KQ (HT):</strong>{" "}
                                {getDateTime(item?.createDateDiagnosticReport)}
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
        {isMobile && (
          <Grid container spacing={1} className="w-100 m-0">
            <Grid item xs={12}>
              <div className="treatment-list-mobile">
                <div className="card-header">
                  <div></div>
                  <div>
                    <ExtraButton
                      setVisibleColumns={setVisibleColumns}
                      visibleColumns={visibleColumns}
                      storageKey="dataMobileTreatmentCustom"
                      columns={columns}
                    />
                  </div>
                </div>
                {(!pageDataHistory?.content ||
                  pageDataHistory?.content.length === 0) && (
                    <div style={{ textAlign: "center", padding: "10px" }}>
                      Không có dữ liệu
                    </div>
                  )}
                {(pageDataHistory?.content || []).map((row, index) => {
                  return (
                    <>
                      <div key={index} className="treatment-card">
                        <>
                          {/* Header của ngày */}
                          {visibleColumns["orderDate"] && (
                            <div className="card-header">
                              <div className="card-stt">
                                📅 Ngày điều trị:{" "}
                                {getDateTime(row?.orderDate, "", "DD/MM/YYYY")}
                              </div>
                              <div className="card-count">
                                ({row?.items?.length} dịch vụ)
                              </div>
                            </div>
                          )}
                          {/* Danh sách item trong ngày */}
                          <div className="card-body">
                            {(row?.items || []).map((item, subIndex) => {
                              stt++;
                              return (
                                <div
                                  key={`${index}-${subIndex}`}
                                  className="treatment-item"
                                >
                                  <div className="item-header">
                                    <span className="item-stt">
                                      {visibleColumns["stt"] && (
                                        <div>#{stt}</div>
                                      )}
                                    </span>
                                    <div />
                                  </div>

                                  {visibleColumns["service"] && (
                                    <div className="field">
                                      <strong>Dịch vụ:</strong>
                                      <div className="pl-1 pr-1">
                                        <div>
                                          <span className="service-code">
                                            {item?.service?.code}
                                          </span>{" "}
                                          <span className="service-name">
                                            {item?.service?.tradeName ||
                                              item?.service?.name}
                                          </span>
                                          {item?.visitCode && (
                                            <>
                                              {" - "}
                                              <span
                                                className="order-code"
                                                style={{
                                                  color: "#888",
                                                  fontSize: "14px",
                                                }}
                                              >
                                                {item?.visitCode}
                                              </span>
                                            </>
                                          )}
                                        </div>

                                        {item?.times && (
                                          <span className="font-size-12">
                                            {`Lần điều trị: ${item?.times || 0
                                              } ${item?.unLimited
                                                ? "♾️"
                                                : "| " +
                                                (item?.totalTreatmentTimes ||
                                                  0)
                                              }`}
                                          </span>
                                        )}
                                      </div>
                                    </div>
                                  )}

                                  {visibleColumns["result"] && (
                                    <div className="field">
                                      <strong>Kết quả:</strong>
                                      {item?.diagnosticReport ? (
                                        <div>
                                          <div>
                                            <strong>Kết luận:</strong>{" "}
                                            {item?.diagnosticReport?.conclude ||
                                              "Không có"}
                                          </div>
                                          <div>
                                            <strong>Ghi chú:</strong>{" "}
                                            {item?.diagnosticReport?.note ||
                                              "Không có"}
                                          </div>
                                        </div>
                                      ) : (
                                        <i style={{ color: "#999" }}>
                                          Chưa có kết quả
                                        </i>
                                      )}
                                    </div>
                                  )}

                                  {visibleColumns["department"] && (
                                    <div className="field">
                                      <strong>Cơ sở:</strong>{" "}
                                      {item?.department?.name || ""}
                                    </div>
                                  )}

                                  {visibleColumns["room"] && (
                                    <div className="field">
                                      <strong>Phòng:</strong>{" "}
                                      {item?.room?.name || ""}
                                    </div>
                                  )}

                                  {visibleColumns["assigner"] && (
                                    <div className="field">
                                      <strong>Người chỉ định:</strong>{" "}
                                      {item?.assigner?.staffName || ""}
                                    </div>
                                  )}

                                  {visibleColumns["orderDateDetail"] && (
                                    <div className="field">
                                      <strong>Ngày chỉ định:</strong>{" "}
                                      {getDateTime(item?.orderDate)}
                                    </div>
                                  )}

                                  {visibleColumns["performDate"] && (
                                    <div className="field">
                                      <strong>Thời gian thực hiện:</strong>{" "}
                                      {getDateTime(item?.performDate)}
                                    </div>
                                  )}

                                  {visibleColumns["performer"] && (
                                    <div className="field">
                                      <strong>Người thực hiện:</strong>
                                      {item?.encounterParticipants?.map(
                                        (el, ind) => (
                                          <div>
                                            <span className="service-name">
                                              {el?.staff?.staffName}
                                              {": "}
                                            </span>
                                            <span
                                              className="service-code"
                                              style={{
                                                fontWeight: "400",
                                                fontSize: "12px",
                                                fontStyle: "italic",
                                              }}
                                            >
                                              {el?.position?.name}{" "}
                                              {el?.isMain ? " - ⭐" : ""}
                                            </span>
                                          </div>
                                        )
                                      )}
                                    </div>
                                  )}

                                  {visibleColumns["status"] && (
                                    <div className="field">
                                      <strong>Trạng thái:</strong>{" "}
                                      <span>
                                        {SERVICE_REQUEST_STATUS?.find(
                                          (it) => it.value === item?.itemStatus
                                        )?.name || t("Chưa xác định")}
                                      </span>
                                    </div>
                                  )}

                                  {visibleColumns["hasImg"] && (
                                    <div className="field">
                                      <strong>Đã up ảnh:</strong>
                                      {item?.hasImg ? "✔️" : "❌"}
                                    </div>
                                  )}

                                  {visibleColumns["note"] && (
                                    <div className="field">
                                      <strong>Ghi chú:</strong>{" "}
                                      {item?.note || ""}
                                    </div>
                                  )}

                                  {visibleColumns["createdInfo"] && (
                                    <div className="field">
                                      <strong>Thông tin tạo / sửa:</strong>
                                      <div className="sub-field">
                                        <div>
                                          <strong>Tạo:</strong>{" "}
                                          {item?.createdBy || ""}
                                        </div>
                                        <div>
                                          <strong>Sửa:</strong>{" "}
                                          {item?.modifiedBy || ""}
                                        </div>
                                      </div>
                                    </div>
                                  )}

                                  {visibleColumns["createDateInfo"] && (
                                    <div className="field">
                                      <strong>
                                        Ngày tạo HT / Thời gian nhập (theo HT):
                                      </strong>
                                      <div className="sub-field">
                                        <div>
                                          <strong>Tạo HT:</strong>{" "}
                                          {getDateTime(item?.createDate)}
                                        </div>
                                        <div>
                                          <strong>Nhập KQ (HT):</strong>{" "}
                                          {getDateTime(
                                            item?.createDateDiagnosticReport
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        </>
                      </div>
                    </>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        )}
        <GlobitsPagination
          pageIndex={searchData.pageIndex}
          pageSize={searchData.pageSize}
          totalElements={pageDataHistory?.totalElements}
          totalPages={pageDataHistory?.totalPages}
          setPageIndex={(pageIndex) => handleChangeFormSearch({ pageIndex })}
          setPageSize={(pageSize) => handleChangeFormSearch({ pageSize })}
        />
      </Grid>
    );
  }
);

const ExtraButton = ({ setVisibleColumns, visibleColumns, columns }) => {
  const classes = useStylesExtraButton();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const visibleColumnsFormat = Object.entries(visibleColumns);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const id = !!anchorEl ? "simple-popover" : undefined;
  const onToggle = (index, state) => {
    let newArr = visibleColumnsFormat?.map((el, ind) => {
      if (ind === index) return [el[0], state];
      else return el;
    });
    const obj = Object.fromEntries(newArr);
    setVisibleColumns(obj);

    localStorage.setItem(
      "dataTableTreatmentServiceCustom",
      JSON.stringify(obj)
    );
    // return newArr;
  };

  return (
    <div>
      <Button
        aria-describedby={id}
        variant="contained"
        color="primary"
        onClick={handleClick}
        className="extra-button-table"
      >
        <div className="flex align-center justify-between">
          {"Xem thêm"}
          <Tooltip title="Xem thêm">
            {!!anchorEl ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
          </Tooltip>
        </div>
      </Button>
      <Popover
        id={id}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Typography className={classes.typography}>
          {visibleColumnsFormat &&
            visibleColumnsFormat?.map((el, index) => (
              <CustomToggle
                el={el}
                onToggle={onToggle}
                index={index}
                columns={columns}
              />
            ))}
        </Typography>
      </Popover>
    </div>
  );
};

const CustomToggle = ({ onToggle, el, index, columns }) => {
  const [active, setActive] = useState(el[1]);

  const handleClick = (index, e) => {
    setActive((prev) => !prev);
    if (onToggle) {
      onToggle(index, !active);
    }
  };

  return (
    <div className="flex gap-2 align-center toggle-wraper">
      <div className="toggle-container">
        <div
          className={`custom-toggle ${active ? "active" : ""}`}
          onClick={() => handleClick(index)}
        >
          <div className="toggle-circle" />
        </div>
        <div className="flex justify-between align-center" style={{ flex: 1 }}>
          <span className="toggle-label">{columns[el[0]]}</span>
        </div>
      </div>
    </div>
  );
};

export default memo(observer(HistoryTreatmentService));
